import { CounterCustomerChargeMaintenanceConstant } from "presentation/constant/CounterCustomerCharge/CounterCustomerChargeMaintenanceConstant";
import { useCounterCustomerChargeMaintenanceVM } from "presentation/hook/CounterCustomerCharge/useCounterCustomerChargeMaintenanceVM";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import { memo, useState } from "react";
import { DialogModal, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import AdditionalChargeVesselContent from "./AdditionalChargeVesselContent";

const AdditionalChargeVesselComp: React.FC = () => {
    const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
    const counterCustomerChargeVM = useCounterCustomerChargeMaintenanceVM();
    const { isShowFindVesselPanel } = counterCustomerChargeState;
    const [isLoading,] = useState(false);

    const handleCloseDialog = () => {
        counterCustomerChargeVM.closeCompDialog();
    }

    if (isLoading) return <Loader Indicator="Spinner" size="Medium" />;

    return <DialogModal style={{ minWidth: '62vw', minHeight: '82vh' }}
        appendTo='self'
        showButton={false}
        visible={isShowFindVesselPanel}
        positions="center"
        resizable={false}
        header={
            <div className="im-charge-data-search-confirm-modal-header">
                <span className="name">{CounterCustomerChargeMaintenanceConstant.VESSEL.TITLE}</span>
                <IconButton fileName='Icon-cross' size="medium" onClick={handleCloseDialog} tooltipDisable={true} />
            </div>
        }
        dialogContent={<AdditionalChargeVesselContent />}
        className="im-charge-data-search-confirm-modal"
    />
}

export default memo(AdditionalChargeVesselComp);